import { EmptyView } from '@components'

import { ReactElement, useCallback } from 'react'
import { useNavigate } from 'react-router'

import { DepositInvoicesModalImage } from '../../../../../../assets/images'
import { Scope } from '../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../enums/trackingContext'
import { useSegment } from '../../../../../../hooks'

interface QuotesListEmptyProps {
  quoteNewUrl?: string
}

export const QuotesListEmpty = ({ quoteNewUrl }: QuotesListEmptyProps): ReactElement => {
  const navigate = useNavigate()
  const { track } = useSegment()

  const handleCreateQuoteClick = useCallback(() => {
    track('XXX - Invoicing Core - Quotes List - Create new quote clicked', {
      isEmptyQuotesList: true,
    })

    if (quoteNewUrl) {
      navigate(quoteNewUrl)
    }
  }, [navigate, quoteNewUrl, track])

  return (
    <EmptyView
      buttonSize="md"
      descriptionColor="discreet"
      illustration={<DepositInvoicesModalImage />}
      onClick={handleCreateQuoteClick}
      scopes={Scope.OfferWrite}
      showCTA
      tButton="quotes.empty_list.buttonText"
      tDescription="quotes.empty_list.description"
      tTitle="quotes.empty_list.title"
      trackingContext={TrackingContext.CreateQuote}
    />
  )
}
